import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PageHeaderService {
    readonly actionLabel = signal<string | null>(null);
    readonly action = signal<(() => void) | null>(null);

    setAction(label: string | null, action: (() => void) | null): void {
        this.actionLabel.set(label);
        this.action.set(action);
    }

    clearAction(): void {
        this.setAction(null, null);
    }
}
